<div class="passwordStrength">
  <p class="passwordStrength__label"><small>{{ label }}</small></p>
  <div class="passwordStrength__bars">
    <div class="passwordStrength__bar" [style.background]="bar0Color"></div>
    <div class="passwordStrength__bar" [style.background]="bar1Color"></div>
    <div class="passwordStrength__bar" [style.background]="bar2Color"></div>
    <div class="passwordStrength__bar" [style.background]="bar3Color"></div>
    <div class="passwordStrength__bar" [style.background]="bar4Color"></div>
  </div>
  <p *ngIf="strengthLabel" class="passwordStrength__strengthLabel"><small>{{ strengthLabel }}</small></p>
</div>
